import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { SelectionPendingService } from '@shared/services/selection-pending.service';

/**
 * Legt einen Ladeindikator über die Detailansicht, solange eine neu angeklickte
 * Auswahl noch nicht angekommen ist. Der Inhalt darunter bleibt sichtbar, wird
 * aber abgedeckt - so ist erkennbar, dass die Anzeige noch nicht aktuell ist.
 *
 * Die Komponente holt ihren Zustand selbst aus dem SelectionPendingService,
 * dadurch genügt in der Vorlage eine einzige Zeile.
 */
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'pending-overlay',
  templateUrl: './pending-overlay.component.html',
  styleUrls: ['./pending-overlay.component.css'],
})
export class PendingOverlayComponent {
  readonly pending$: Observable<boolean>;

  constructor(selectionPending: SelectionPendingService) {
    this.pending$ = selectionPending.pending$;
  }
}
